import React, { useContext } from 'react';
import styled from 'styled-components';
import { Particles as ReactParticles } from 'react-tsparticles';

import { AppContext } from './../App/AppContext';

const P = {
  Container: styled.div`
    transition: background-color 0.5s linear;
    position: absolute;
    background-color: ${({ theme }) => theme.background};
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50% 50%;
    z-index: 0;
  `,
};

export const Matrix = () => {
  const { theme } = useContext(AppContext);

  var setContext = (ref) => {
    let ctx = ref.getContext('2d')
    //making the canvas full screen
    ref.height = window.innerHeight;
    ref.width = window.innerWidth;

    //japanese characters
    var japan = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ123456789@#$%^&*()*&^%+-/~{[|`]}ば司立肌切チじを飯端めなだごさ対全分人ぜち使";
    //converting the string into an array of single characters
    japan = japan.split("");

    var font_size = 18;
    var columns = ref.width/font_size; //number of columns for the rain
    //an array of drops - one per column
    var drops = [];
    //x below is the x coordinate
    //1 = y co-ordinate of the drop(same for every drop initially)
    for(var x = 0; x < columns; x++)
      drops[x] = 1;
    
    let colors = ["#0F0", "#F00", "#00F", "#0FF", "#FF0", "#F0F"]

    let color = colors[Math.floor(Math.random() * colors.length)]

    //drawing the characters
    function draw()
    {
        if (ref.height !== window.innerHeight || ref.width !== window.innerWidth){
            //making the canvas full screen
            ref.height = window.innerHeight;
            ref.width = window.innerWidth;
        }
      //Black BG for the canvas
      //translucent BG to show trail
      ctx.fillStyle = "rgba(0, 0, 0, 0.05)";
      ctx.fillRect(0, 0, ref.width, ref.height);
      
      ctx.fillStyle = color;
      ctx.font = font_size + "px arial";
      //looping over drops
      for(var i = 0; i < drops.length; i++)
      {
        //a random japanese character to print
        var text = japan[Math.floor(Math.random()*japan.length)];
        //x = i*font_size, y = value of drops[i]*font_size
        ctx.fillText(text, i*font_size, drops[i]*font_size);
        
        //sending the drop back to the top randomly after it has crossed the screen
        //adding a randomness to the reset to make the drops scattered on the Y axis
        if(drops[i]*font_size > ref.height && Math.random() > 0.975)
          drops[i] = 0;
        
        //incrementing Y coordinate
        drops[i]++;
      }
    }

    setInterval(draw, 35);
      // draw stuff
  }

  return (
    <P.Container theme={theme}>
      <canvas ref={setContext}></canvas>
    </P.Container>
  );
};
